export const endingPoints = (localeName, number, grammarCase) => {
    if (localeName === 'ru') {
        let ending = 'ов';
        const lastDigit = number % 10;
        const lastTwoDigits = number % 100;
        if (lastDigit === 1 && lastTwoDigits !== 11) {
            ending = grammarCase === 'genitive' ? 'а' : "";
        } else if ([2, 3, 4].includes(lastDigit) && grammarCase !== 'genitive') {
            ending = "а";
        }
        return ending;
    } else {
        return number > 1 ? 's' : ''
    }
};

export const getBalancePointsString = ({$locale, price}) => {
    return price.toLocaleString('ru-RU') + " " + String($locale.get('common.point')).toLowerCase() + endingPoints($locale.name, price);
};
